// extracted by mini-css-extract-plugin
module.exports = {"apply":"apply-banner_apply__tgrOn","apply-btn":"apply-banner_apply-btn__bNx6X","applied":"apply-banner_applied__J8SX8"};